import { render, staticRenderFns } from "./XTable.vue?vue&type=template&id=3504a393"
import script from "./XTable.vue?vue&type=script&lang=js"
export * from "./XTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports